import { useIntl } from 'react-intl';
const useIntlNumber = () => {
    const { formatNumber } = useIntl();
    return (value, options) => {
        var _a, _b, _c;
        return formatNumber(value, {
            ...options,
            style: (_a = options === null || options === void 0 ? void 0 : options.style) !== null && _a !== void 0 ? _a : 'decimal',
            minimumFractionDigits: (_b = options === null || options === void 0 ? void 0 : options.minimumFractionDigits) !== null && _b !== void 0 ? _b : 2,
            maximumFractionDigits: (_c = options === null || options === void 0 ? void 0 : options.maximumFractionDigits) !== null && _c !== void 0 ? _c : 2,
        });
    };
};
export default useIntlNumber;
